module.exports = __webpack_public_path__ + "img/HU12248256.9a091466.png";